var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageInputIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#B2C73D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_118)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5075 18.1579C14.1851 18.1579 13.1094 19.244 13.1094 20.5837V37.5708C13.1094 38.9099 14.183 39.9966 15.5075 39.9966H39.4913C40.8137 39.9966 41.8894 38.9105 41.8894 37.5708V20.5837C41.8894 19.2446 40.8157 18.1579 39.4913 18.1579H35.7896C35.1276 18.1579 34.4123 17.6438 34.3377 17.429C33.8723 16.089 32.4216 15.0034 31.0973 15.0034H23.9014C22.5783 15.0034 21.1263 16.0894 20.661 17.429C20.5212 17.8316 19.8741 18.1579 19.2091 18.1579H15.5075ZM27.4994 36.3568C31.4731 36.3568 34.6944 33.0976 34.6944 29.0772C34.6944 25.0568 31.4731 21.7977 27.4994 21.7977C23.5257 21.7977 20.3044 25.0568 20.3044 29.0772C20.3044 33.0976 23.5257 36.3568 27.4994 36.3568ZM27.4994 32.717C29.4862 32.717 31.0969 31.0874 31.0969 29.0772C31.0969 27.067 29.4862 25.4375 27.4994 25.4375C25.5125 25.4375 23.9019 27.067 23.9019 29.0772C23.9019 31.0874 25.5125 32.717 27.4994 32.717Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.78,
    height: 24.9932,
    fill: "white",
    transform: "translate(13.1094 15.0034)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageInputIcon);
export default __webpack_public_path__ + "static/media/image_input_icon.f02fa0a8ef808272accbc565f9a170d5.svg";
export { ForwardRef as ReactComponent };